import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getListWithAuthenticated,
  postApiWithAuthenticated,
} from "../ApiMethods/ApiMethod";

const LeadListBaseUrl = `${Base_Url}/Lead`;

export const GetLeadList = async (params, token) => {
  //
  let url = `${LeadListBaseUrl}/GetLeadList`;

  const res = await postApiWithAuthenticated(url, params, token);
  return res;
};
export const AddUpdateLead = async (params) => {
  let url = `${LeadListBaseUrl}/AddUpdateLead`;
  try {
    const res = await postApiWithAuthenticated(url, params);
    return res;
  } catch (error) {
    console.error("Error adding appointment:", error);
    throw error; // Rethrow error for handling in the calling function
  }
};

export const GetLeadModel = async (id) => {
  let url = `${LeadListBaseUrl}/GetLeadModel?LeadKeyID=${id}`;

  const res = await getListWithAuthenticated(url);
  return res;
};
export const ChangeLeadStatus = async (params) => {
  let url = `${LeadListBaseUrl}/ChangeLeadStatus`;
  try {
    const res = await postApiWithAuthenticated(url, params);
    return res;
  } catch (error) {
    console.error("Error to change Lead:", error);
    throw error; // Rethrow error for handling in the calling function
  }
};

export const AssignLeadSalesman = async (params) => {
  //
  let url = `${LeadListBaseUrl}/AssignLeadSalesman`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};

export const TransferMultipleLeads = async (params) => {
  //
  let url = `${LeadListBaseUrl}/MultipleLeadAssignToSalesman`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};

export const GetESTAndBOQLogList = async (params) => {
  //
  let url = `${LeadListBaseUrl}/GetESTAndBOQLogList`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};
export const GetPOEditRequestLeadList = async (params) => {
  //
  let url = `${LeadListBaseUrl}/GetPOEditRequestLeadList`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};
export const AddUpdateApproveRejectEditPORequest = async (params) => {
  //
  let url = `${LeadListBaseUrl}/AddUpdateApproveRejectEditPORequest`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};

export const GetPOModel = async (id) => {
  let url = `${LeadListBaseUrl}/GetPurchaseOrderModel?LeadKeyID=${id}`;

  const res = await getListWithAuthenticated(url);
  return res;
};

export const GetPOEditRequestLogList = async (params) => {

  let url = `${LeadListBaseUrl}/GetPOEditRequestLogList`;
  const res = await postApiWithAuthenticated(url, params);
  return res;
};
export const GetUnprocessedOrderLeadList = async (params) => {

  let url = `${LeadListBaseUrl}/GetUnprocessedOrderLeadList`;
  const res = await postApiWithAuthenticated(url, params);
  return res;
};